import React from 'react';
import Navbar from '../components/Navbar';
import './Privacy.css';

function Privacy() {
    return (
        <div className="page-container privacy-page">
            <Navbar />

            <section className="privacy-hero">
                <div className="container">
                    <div className="privacy-hero-content">
                        <span className="section-badge">JURIDISK INFORMASJON</span>
                        <h1 className="privacy-title">
                            Personvernerklæring <span className="gradient-text"></span>
                        </h1>
                        <p className="privacy-subtitle">
                            Sist oppdatert: 19. mars 2026
                        </p>
                    </div>
                </div>
            </section>

            <section className="privacy-content">
                <div className="container">
                    <div className="privacy-wrapper">
                        <div className="privacy-section">
                            <p>
                                Denne personvernerklæringen (heretter "Erklæringen") fastsetter hvordan plattformen samler inn, bruker, lagrer og utleverer informasjon om brukerne.
                                Den beskriver også praksisen vi bruker for slik informasjon, dine personvernrettigheter og valgener du har angående dine data.
                                For klarhetens skyld gjelder denne erklæringen for alle brukere av plattformen (heretter "Studenter", "Du").
                            </p>
                            <p>
                                Ved å få tilgang til og bruke plattformen, oppgi dine personopplysninger eller samtykke når du blir tilbudt et valg, godtar du innsamling, bruk og utlevering av informasjon i samsvar med denne erklæringen og vilkårene for bruk. Vi påtar oss intet ansvar som følge av dine handlinger.
                                Hvis du ikke er enig i noen bestemmelse i denne erklæringen og/eller vilkårene for bruk, må du avstå fra å bruke plattformen og dens tjenester, og forlate den umiddelbart.
                                Hvis informasjonen du oppgir bryter med vilkårene i denne erklæringen eller vilkårene for bruk, kan vi slette den og begrense din tilgang til plattformen uten forvarsel eller ansvar overfor deg.
                                Begreper brukt i denne erklæringen som ikke er definert, skal tolkes i samsvar med våre vilkår for bruk.
                                Les erklæringen nøye før du bruker tjenestene våre. Hvis du har spørsmål, vennligst kontakt oss via de angitte kanalene.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Personopplysninger</h2>
                            <p>
                                "Personopplysninger" betyr data som identifiserer studenten, for eksempel fornavn og etternavn, identifikasjonsnummer, e-postadresse, alder, kjønn, plassering, bilder og/eller telefonnummer oppgitt under registrering eller senere.
                            </p>
                            <p>
                                "Sensitiv personinformasjon" inkluderer: (i) passord og økonomiske data (unntatt de siste 4 sifrene på kort), (ii) helseopplysninger, (iii) offentlige identifikatorer (biometri, skatte-ID, passopplysninger), (iv) data om seksuell orientering, rase, politisk eller religiøs overbevisning, (v) kontodetaljer, eller (vi) alle data klassifisert como "spesielle kategorier av opplysninger" i henhold til GDPR, CCPA eller andre gjeldende personvernlover.
                            </p>
                            <p>
                                Bruken av begrepet "Personopplysninger" inkluderer "Sensitiv personinformasjon" når det er aktuelt i henhold til konteksten.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Informasjon vi samler inn</h2>
                            <p>
                                Vi kan samle inn både personlig og ikke-personlig informasjon på ulike måter, inkludert ved besøk på plattformen, registrering og andre aktiviteter knyttet til våre tjenester. Vær oppmerksom på følgende:
                            </p>
                            <ul>
                                <li>Vi ber ikke om personopplysninger med mindre det er strengt nødvendig (for eksempel for registrering).</li>
                                <li>Vi deler ikke personopplysningene dine med tredjeparter, unntatt i tilfeller av lovhåndhevelse, produktutvikling eller beskyttelse av våre rettigheter.</li>
                                <li>Vi lagrer bare personopplysninger på servere så lenge det er nødvendig for drift av plattformen.</li>
                                <li>For å laste opp brukerinnhold brukes https://spayeeservers1.com.</li>
                            </ul>

                            <p><strong>Personlig identifiserbar informasjon:</strong> Vi samler bare inn slik informasjon (navn, e-post) hvis du oppgitt den frivillig. Du kan nekte, men dette kan begrense tilgangen til visse funksjoner på plattformen.</p>

                            <p><strong>Ikke-personlig informasjon:</strong> Når du bruker plattformen, kan vi samle inn tekniske data: nettlesernavn, språkinnstillinger, type operativsystem, internettleverandør og andre lignende data.</p>

                            <p><strong>Informasjonskapsler (Cookies):</strong> Plattformen vår kan bruke informasjonskapsler for å forbedre brukeropplevelsen. Du kan deaktivere dem i nettleserinnstillingene dine, men dette kan påvirke funksjonaliteten til visse deler av nettstedet.</p>
                        </div>

                        <div className="privacy-section">
                            <h2>Hvordan vi bruker og deler informasjon</h2>
                            <p>Vi bruker informasjonen til følgende formål:</p>
                            <ul>
                                <li><strong>For å gi tilgang:</strong> For kundeservice, behandling av kjøp, dataverifisering og løsning av tekniske problemer på plattformen.</li>
                                <li><strong>For forbedring og sikkerhet:</strong> For å analysere bruken av nettstedet, konfigurere tilpasning og forhindre svindel eller misbruk av nettverket.</li>
                                <li><strong>For kommunikasjon og markedsføring:</strong> Vi kan bruke e-posten din til ordrevarsler, nyheter, nye produkter eller for å motta tilbakemeldinger.</li>
                            </ul>
                            <p>Vi selger eller bytter ikke bort personopplysningene dine. Vi kan dele generelle aggregerte demografiske data, som ikke er knyttet til spesifikke enkeltpersoner, med våre partnere for formålene som er angitt ovenfor.</p>
                        </div>

                        <div className="privacy-section">
                            <h2>Dine rettigheter</h2>
                            <p>Alle studenter har følgende rettigheter:</p>
                            <ul>
                                <li><strong>Rett til innsyn:</strong> Du kan be om bekreftelse på og innsyn i personopplysningene vi lagrer om deg.</li>
                                <li><strong>Rett til retting:</strong> Du kan kreve korrigering av unøyaktige personopplysninger.</li>
                                <li><strong>Rett til begrensning:</strong> Under visse omstendigheter kan du begrense videre utlevering av dine data.</li>
                                <li><strong>Rett til sletting:</strong> Du kan be om fullstendig sletting av personopplysningene dine fra systemet vårt.</li>
                            </ul>
                        </div>

                        <div className="privacy-section">
                            <h2>Grenseoverskridende dataoverføring</h2>
                            <p>
                                Informasjonen din kan lagres og behandles på servere og databaser tilhørende Amazon Web Services (AWS) i India, samt i andre land, avhengig av plasseringen til våre partnere og tjenesteleverandører.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Klager og kontakt</h2>
                            <p>
                                Hvis du har spørsmål om denne erklæringen, ønsker å utøve dine rettigheter, eller har klager, kan du kontakte oss på e-post: <a href="mailto:support@talktokrishna.ai">support@talktokrishna.ai</a>.
                            </p>
                        </div>
                    </div>
                </div>

            </section>
        </div>
    );
}

export default Privacy;

